import * as React from "react";
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import GlassContainer from "../../../components/liquid-glass";

type VaultGridCardProps = {
  title: React.ReactNode;
  onClick: () => void;
  titleIcon?: React.ReactNode;
  rightAction?: React.ReactNode;
  chips?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  minHeight?: number;
  sx?: SxProps<Theme>;
};

export default function VaultGridCard({
  title,
  onClick,
  titleIcon,
  rightAction,
  chips,
  body,
  footer,
  minHeight = 176,
  sx,
}: VaultGridCardProps) {
  return (
    <GlassContainer
      blur={18}
      radius={14}
      sx={{ mt: 0, cursor: "pointer", ...((sx ?? {}) as Record<string, unknown>) }}
    >
      <Card
        variant="outlined"
        sx={{
          minHeight,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "transparent",
          border: "0px solid transparent",
        }}
      >
        <CardActionArea
          onClick={onClick}
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "center",
            p: 2,
            textAlign: "left",
            "& .MuiCardActionArea-focusHighlight": {
              borderRadius: 0,
            },
          }}
        >
          <CardContent
            sx={{
              p: 0,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 1,
              textAlign: "left",
            }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ width: "100%" }}
            >
              {titleIcon ? (
                <Box sx={{ display: "inline-flex", flexShrink: 0 }}>
                  {titleIcon}
                </Box>
              ) : null}

              <Typography
                sx={{
                  flex: 1,
                  minWidth: 0,
                  fontWeight: 700,
                  fontSize: "0.92rem",
                  lineHeight: 1.35,
                  color: "inherit",
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                }}
              >
                {title}
              </Typography>

              {rightAction ? (
                <Box sx={{ flexShrink: 0 }} onClick={(ev) => ev.stopPropagation()}>
                  {rightAction}
                </Box>
              ) : null}
            </Stack>

            {chips ? (
              <Stack
                direction="row"
                spacing={0.75}
                flexWrap="wrap"
                useFlexGap
                sx={{ width: "100%" }}
              >
                {chips}
              </Stack>
            ) : null}

            <Box sx={{ width: "100%", color: "inherit" }}>{body}</Box>

            {footer ? <Box sx={{ width: "100%" }}>{footer}</Box> : null}
          </CardContent>
        </CardActionArea>
      </Card>
    </GlassContainer>
  );
}
